/* global i18n  */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { flatten, pathEq, reject, values, compose } from 'ramda'
import { isNotEmpty } from 'ramda-adjunct'
import { xhrPost } from '../../../../helpers/http.js'
import { baseUrl } from '../../../../common/constants.js'
import s from '../../style.module.scss'

const BankPay = () => {
  const flatItemList = useSelector((state) => flatten(values(state.Cart.items)))

  const dispatch = useDispatch()

  const isLoading = useSelector((state) => state.Cart.isLoading)
  const isUnderPayment = useSelector((state) => state.Cart.isUnderPayment)
  const setIsLoading = (isLoading) => {
    dispatch({
      type: 'Cart.setIsLoading',
      payload: {
        isLoading
      }
    })
  }

  const setIsUnderPayment = (isUnderPayment) => {
    dispatch({
      type: 'Cart.setIsUnderPayment',
      payload: {
        isUnderPayment
      }
    })
  }

  const setItems = (items) => {
    dispatch({
      type: 'Cart.setItems',
      payload: {
        items
      }
    })
  }

  const apiBankPay = async () => {
    return xhrPost(`${baseUrl}/web/cart/payment/bank`)
  }

  const BankPay = async () => {
    setIsLoading(true)
    setItems(await apiBankPay())
    setIsUnderPayment(true)
    setIsLoading(false)
  }

  const hasBankPayableItems = compose(
    isNotEmpty,
    reject(pathEq(['commerceinfo', 'statusText'], 'payment pending'))
  )(flatItemList)

  return (
    <>
      <h3>{i18n.t('cart_bank_payment_header')}</h3>
      <div className={s.paymentInfoContainer}>
        <h4>{i18n.t('cart_bank_payment_info_header')}</h4>
        <div>{i18n.t('cart_bank_payment_info_text')}</div>
        {!isUnderPayment && (
          <button className="btn-primary" disabled={isLoading || !hasBankPayableItems} onClick={BankPay}>
            {i18n.t('cart_bank_pay')}
          </button>
        )}
      </div>
    </>
  )
}

export default BankPay
